import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/components/base-component';
import { Subscriber } from 'src/app/shared/models/signature.model';
import { Signer } from 'src/app/shared/models/signer';
@Component({
  selector: 'app-signers-button',
  templateUrl: './signers-button.component.html',
  styleUrls: ['./signers-button.component.scss']
})
export class SignersButtonComponent extends BaseComponent {

  @Input() signerList:Subscriber[] = [];
  showHistory = false

  constructor() { super(); }

}
